export const cookiesConf = {
    savedID: { key: "savedID", expiration: "100y" },
    RefreshToken: { key: "RefreshToken", expiration: "30d" },
    id: { key: "id", expiration: "30d" },
    name: { key: "name", expiration: "120m" },
    phone_number: { key: "phone_number", expiration: "120m" },
    email: { key: "email", expiration: "120m" },
    office_phone_number: {
        key: "office_phone_number",
        expiration: "120m",
    },
    office_internal_number: {
        key: "office_internal_number",
        expiration: "120m",
    },
    position: { key: "position", expiration: "120m" },
    department: { key: "department", expiration: "120m" },
    permission_group_ids: {
        key: "permission_group_ids",
        expiration: "120m",
    },
    allowed_urls: { key: "allowed_urls" },
    pricePermissionGroupIds: ["1", "2", "11"],
};
